var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMediumSocial(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0422 4.37187L14 3.45156V3.25H10.6828L8.31875 9.1625L5.62969 3.25H2.15156V3.45156L3.27031 4.80469C3.37969 4.90469 3.43594 5.05156 3.42188 5.19844V10.5156C3.45625 10.7078 3.39531 10.9031 3.26094 11.0422L2 12.5781V12.7766H5.57188V12.575L4.3125 11.0437C4.24502 10.9752 4.19427 10.8921 4.16419 10.8008C4.1341 10.7094 4.12551 10.6124 4.13906 10.5172V5.91719L7.275 12.7797H7.63906L10.3359 5.91719V11.3844C10.3359 11.5281 10.3359 11.5578 10.2422 11.6531L9.27188 12.5953V12.7969H13.9781V12.5953L13.0422 11.675C12.9609 11.6125 12.9188 11.5078 12.9359 11.4062V4.64062C12.9278 4.59041 12.9334 4.53895 12.9521 4.49165C12.9708 4.44436 13.0019 4.40298 13.0422 4.37187V4.37187Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediumSocial);
export default __webpack_public_path__ + "static/media/mediumSocial.d438f799e7c785395d2b41fda94807bd.svg";
export { ForwardRef as ReactComponent };